// No backend exists yet for the gamification side of campaigns (quiz, prediction,
// streak, branch, prizes, reviews) — this ships as a static scaffold (matching the
// RewardAds detail page's convention) with generated mock data, ready to be swapped
// for real API calls once the contract exists.

const DAY_LABELS = Array.from({ length: 12 }, (_, index) => `April ${15 + index}`)

function seededRandom(seed) {
  let value = seed
  return () => {
    value = (value * 9301 + 49297) % 233280
    return value / 233280
  }
}

function buildSeries(rand, base, variance) {
  return DAY_LABELS.map((label) => ({ label, value: Math.max(0, Math.round(base + (rand() - 0.4) * variance)) }))
}

function buildCampaignDetail(index) {
  const rand = seededRandom(index * 131 + 7)

  return {
    id: index,
    title: 'Recharge & Win – Fuel Season',
    description: 'Offer NGN 500 fuel voucher for watching ads',
    type: 'Engagement',
    status: 'active',
    thumbnailTone: ['primary', 'purple', 'success', 'gold'][index % 4],
    period: { label: 'May 15 - Jun 15 1016', daysLeft: 31 },
    budget: 100000,
    budgetUsedPercent: 37,
    participantsCount: 12450,
    performanceMultiplier: '3.05x',

    overview: {
      stats: [
        { key: 'qualifying_transactions', label: 'Qualifying Transact...', value: '124,860', trend: 14, tone: 'success' },
        { key: 'unique_participants', label: 'Unique Participants', value: '1,235', trend: 12.6, tone: 'information' },
        { key: 'campaign_sales', label: 'Campaign Sales', value: 'NGN 4,250,000', trend: 21.4, tone: 'discovery' },
        { key: 'prize_cost', label: 'Prize Cost', value: 'NGN 1,050,000', trend: 21.4, tone: 'warning' },
        { key: 'campaign_roi', label: 'Campaign ROI', value: '3.05x', trend: -4.4, tone: 'success' }
      ],
      salesOverTime: {
        series: [{ key: 'sales', label: 'Sales', color: '#1976D2', data: buildSeries(rand, 65000, 40000) }]
      },
      setup: [
        { key: 'campaign_type', label: 'Campaign Type', value: 'Gamification' },
        { key: 'scoring_methods', label: 'Scoring Methods', value: 'Purchase, Quiz, Prediction' },
        { key: 'levels', label: 'Levels', value: '5' },
        { key: 'streaks', label: 'Streaks', value: 'Enabled', tone: 'success' },
        { key: 'prize_model', label: 'Prize Model', value: 'Weekly + Grand Prizes' },
        { key: 'created_on', label: 'Created On', value: 'May 10, 2026' },
        { key: 'last_updated', label: 'Last Updated', value: 'May 18, 2026' },
        { key: 'approved_status', label: 'Approved Status', value: 'Approved', tone: 'success' }
      ],
      funnel: [
        { key: 'reached', label: 'Reached', value: 12450, percent: 100, tone: 'primary' },
        { key: 'engaged', label: 'Engaged', value: 7430, percent: 58, tone: 'success' },
        { key: 'participated', label: 'Participated', value: 3234, percent: 26, tone: 'gold' },
        { key: 'prize_eligible', label: 'Prize Eligible', value: 890, percent: 8, tone: 'danger' }
      ],
      topPrizes: [
        { key: 'fuel_100k', name: 'Fuel Voucher NGN 100,000', value: 'GHS 25.34' },
        { key: 'fuel_50k', name: 'Fuel Voucher NGN 50,000', value: 'GHS 25.34' },
        { key: 'grocery', name: 'Grocery Voucher', value: 'GHS 25.34' },
        { key: 'free_fuel_1', name: 'Free Fuel for a Month', value: 'GHS 25.34' },
        { key: 'free_fuel_2', name: 'Free Fuel for a Month', value: 'GHS 25.34' }
      ],
      levelsStreaks: [
        { level: 'Level 1', coinBonus: '1.0x', pointsBonus: '1.0x' },
        { level: 'Level 2', coinBonus: '1.1x', pointsBonus: '1.2x' },
        { level: 'Level 3', coinBonus: '1.2x', pointsBonus: '1.35x' },
        { level: 'Level 4', coinBonus: '1.35x', pointsBonus: '1.6x' },
        { level: 'Level 5', coinBonus: '1.5x', pointsBonus: '2.0x' }
      ]
    },

    analytics: {
      stats: [
        { key: 'campaign_sales', label: 'Campaign Sales', value: 'NGN 4,450,000', tone: 'purple' },
        { key: 'unique_participants', label: 'Unique Participants', value: '1,235', tone: 'blue' },
        { key: 'engagement_rate', label: 'Engagement Rate', value: '58%', tone: 'success' },
        { key: 'campaign_roi', label: 'Campaign ROI', value: '3.05x', tone: 'primary' },
        { key: 'avg_rating', label: 'Avg. Rating', value: '4.2', tone: 'gold' }
      ],
      performanceTrends: {
        tabs: [
          { key: 'sales', label: 'Sales' },
          { key: 'participants', label: 'Participants' },
          { key: 'transactions', label: 'Transactions' },
          { key: 'engagement', label: 'Engagement' }
        ],
        seriesByTab: {
          sales: [{ key: 'sales', label: 'Sales', color: '#1976D2', data: buildSeries(rand, 65000, 40000) }],
          participants: [{ key: 'participants', label: 'Participants', color: '#7C3AED', data: buildSeries(rand, 900, 400) }],
          transactions: [{ key: 'transactions', label: 'Transactions', color: '#34C759', data: buildSeries(rand, 1500, 600) }],
          engagement: [{ key: 'engagement', label: 'Engagement', color: '#DCA815', data: buildSeries(rand, 50, 25) }]
        }
      },
      funnel: [
        { key: 'reached', label: 'Reached', value: 12450, percent: 100, tone: 'primary' },
        { key: 'engaged', label: 'Engaged', value: 7430, percent: 58, tone: 'success' },
        { key: 'participated', label: 'Participated', value: 3234, percent: 26, tone: 'gold' },
        { key: 'prize_eligible', label: 'Prize Eligible', value: 890, percent: 8, tone: 'blue' }
      ],
      branchPerformance: {
        centerValue: null,
        data: [
          { label: 'Tema Community', percent: 32, color: '#1976D2' },
          { label: 'Spintex Road', percent: 34, color: '#7C3AED' },
          { label: 'Mataheko Market', percent: 20, color: '#60A5FA' },
          { label: 'Achimota Branch', percent: 14, color: '#34C759' },
          { label: 'Others', percent: 10, color: '#DCA815' }
        ]
      },
      snapshot: [
        { key: 'current_week_growth', label: 'Current week growth', value: '+18.3%', tone: 'success' },
        { key: 'new_participants', label: 'New Participants', value: '456' },
        { key: 'repeat_purchase_rate', label: 'Repeat Purchase Rate', value: '37%' },
        { key: 'quiz_prediction_engagement', label: 'Quiz + Prediction engagement', value: '58%' },
        { key: 'best_performing_branch', label: 'Best Performing Branch', value: 'Tema Community' }
      ],
      prizes: [
        { key: 'fuel_100k', name: 'Fuel Voucher NGN 100,000' },
        { key: 'fuel_50k', name: 'Fuel Voucher NGN 50,000' },
        { key: 'grocery', name: 'Grocery Voucher' },
        { key: 'samsung', name: 'Samsung A21' },
        { key: 'free_fuel', name: 'Free Fuel for a Month' }
      ],
      participantQuality: [
        { key: 'returning_customers', label: 'Returning Customers', value: '572', trend: -4, tone: 'purple' },
        { key: 'new_customers', label: 'New Customers', value: '663', trend: 56, tone: 'primary' },
        { key: 'active_users', label: 'Active Users', value: '1,098', tone: 'success' },
        { key: 'inactive_users', label: 'Inactive Users', value: '143', tone: 'danger' }
      ],
      streakInsights: {
        stats: [
          { key: 'active_streak_users', label: 'Active Streak users', value: '642 (52%)', tone: 'success' },
          { key: 'avg_streak', label: 'Avg. Streak', value: '4.5 days', tone: 'blue' }
        ],
        table: [
          { level: 'L1', activeUsers: '25% (309)', coinBonus: '120 coins', pointsBonus: '10x Points' },
          { level: 'L2', activeUsers: '25% (309)', coinBonus: '120 coins', pointsBonus: '10x Points' },
          { level: 'L3', activeUsers: '25% (309)', coinBonus: '120 coins', pointsBonus: '10x Points' },
          { level: 'L4', activeUsers: '25% (309)', coinBonus: '120 coins', pointsBonus: '10x Points' },
          { level: 'L5', activeUsers: '25% (309)', coinBonus: '120 coins', pointsBonus: '10x Points' }
        ]
      }
    },

    transactions: {
      stats: [
        { key: 'total_transactions', label: 'Total Transactions', value: 'NGN 4,450,000', tone: 'purple' },
        { key: 'successful', label: 'Successful', value: '1,235', suffix: '96.98%', tone: 'success' },
        { key: 'pending', label: 'Pending', value: '412', suffix: '2.20%', tone: 'gold' },
        { key: 'failed', label: 'Failed', value: '24', suffix: '1.85%', tone: 'danger' },
        { key: 'total_volume', label: 'Total Volume', value: 'NGN 24,643,200', tone: 'blue' }
      ],
      rows: Array.from({ length: 7 }, (_, i) => {
        const statuses = ['Successful', 'Successful', 'Successful', 'Failed', 'Successful', 'Pending', 'Successful']
        const types = ['Airtime', 'Data Bundle', 'Subscription', 'Airtime', 'Data Bundle', 'Airtime', 'Subscription']
        const names = ['Kwame Boateng', 'Ama Asante', 'Abena Osei', 'Kofi Mensah', 'Yaa Adomako', 'Esi Ofori', 'Nana Kwame']
        return {
          id: `TXN-20260631-${String(1 + i).padStart(4, '0')}`,
          user: names[i],
          type: types[i],
          amount: `NGN ${(1000 + i * 500).toLocaleString()}`,
          status: statuses[i],
          date: `Jun ${16 + i}, 2026 10:32 AM`
        }
      })
    },

    participants: {
      stats: [
        { key: 'total_participants', label: 'Total Participants', value: 'NGN 4,450,000', tone: 'purple' },
        { key: 'active_participants', label: 'Active Participants', value: '9,235', suffix: '74.1% of total', tone: 'success' },
        { key: 'new_this_week', label: 'New This Week', value: '1,234', trend: 12.6, tone: 'blue' },
        { key: 'top_referrers', label: 'Top Referrers', value: '243', suffix: 'Users', tone: 'gold' },
        { key: 'avg_points_earned', label: 'Avg. Points Earned', value: '4,980', suffix: 'Per participants', tone: 'primary' }
      ],
      rows: Array.from({ length: 7 }, (_, i) => ({
        id: `PT-${i}`,
        user: 'Kwame Boateng',
        phone: '+233 54 765 4321',
        joinedOn: 'May 16, 2026',
        lastActive: 'Jun 1, 2026 08:45 AM',
        pointsEarned: '8,250',
        transactions: 18,
        status: i % 3 === 1 ? 'Inactive' : 'Active'
      }))
    },

    quiz: {
      stats: [
        { key: 'quiz_plays', label: 'Quiz Plays', value: '18,234', trend: 12.6, tone: 'purple' },
        { key: 'unique_players', label: 'Unique Players', value: '7,323', trend: 0.8, tone: 'blue' },
        { key: 'completion_rate', label: 'Completion Rate', value: '72.8%', trend: 0.8, tone: 'success' },
        { key: 'average_score', label: 'Average Score', value: '68.3%', trend: 18.3, tone: 'primary' },
        { key: 'correct_answer_rate', label: 'Correct Answer Rate', value: '71.3%', trend: -6.5, tone: 'gold' },
        { key: 'quiz_points_earned', label: 'Quiz Points Earned', value: '282,550', trend: 9.2, tone: 'gold' }
      ],
      performance: {
        tabs: [
          { key: 'plays', label: 'Quiz Plays Over Time' },
          { key: 'score', label: 'Avg Score Over Time' },
          { key: 'completion', label: 'Completion Rate Over Time' }
        ],
        seriesByTab: {
          plays: [{ key: 'plays', label: 'Quiz Plays', color: '#7C3AED', data: buildSeries(rand, 1500, 500) }],
          score: [{ key: 'score', label: 'Avg Score', color: '#7C3AED', data: buildSeries(rand, 65, 20) }],
          completion: [{ key: 'completion', label: 'Completion Rate', color: '#7C3AED', data: buildSeries(rand, 60, 30) }]
        }
      },
      rows: Array.from({ length: 7 }, (_, i) => ({
        id: `QZ-${i}`,
        rank: i + 1,
        user: 'Kwame Boateng',
        quizPlays: 43,
        avgScore: '74.8%',
        correctRate: '78.3%',
        pointsEarned: '8,250'
      }))
    },

    prediction: {
      stats: [
        { key: 'prediction_entry', label: 'Prediction Entry', value: '4,532', trend: 12.6, tone: 'purple' },
        { key: 'unique_predictors', label: 'Unique Predictors', value: '7,323', trend: 0.8, tone: 'blue' },
        { key: 'prediction_accuracy', label: 'Prediction Accuracy', value: '72.8%', trend: 0.8, tone: 'success' },
        { key: 'settled_matches', label: 'Settled Matches', value: '68.3%', trend: 18.3, tone: 'success' },
        { key: 'correct_predictions', label: 'Correct Predictions', value: '71.3%', trend: -6.5, tone: 'success' },
        { key: 'boost_points_earned', label: 'Boost Points Earned', value: '282,550', trend: 9.2, tone: 'gold' }
      ],
      performance: {
        tabs: [
          { key: 'entry', label: 'Prediction Entry Over Time' },
          { key: 'accuracy', label: 'Prediction Accuracy Over Time' },
          { key: 'boosts', label: 'Boosts Points Over Time' }
        ],
        seriesByTab: {
          entry: [{ key: 'entry', label: 'Prediction Entry', color: '#7C3AED', data: buildSeries(rand, 550, 300) }],
          accuracy: [{ key: 'accuracy', label: 'Accuracy', color: '#7C3AED', data: buildSeries(rand, 65, 20) }],
          boosts: [{ key: 'boosts', label: 'Boost Points', color: '#7C3AED', data: buildSeries(rand, 8000, 3000) }]
        }
      },
      topMatches: [
        { rank: 1, match: 'Nigeria vs Ghana', prediction: '12,393' },
        { rank: 2, match: 'Nigeria vs Ghana', prediction: '10,393' },
        { rank: 3, match: 'Nigeria vs Ghana', prediction: '988' },
        { rank: 4, match: 'Nigeria vs Ghana', prediction: '879' }
      ],
      rows: Array.from({ length: 7 }, () => ({
        rank: 1,
        user: 'Kwame Boateng',
        predictionEntries: 286,
        accuracy: '68%',
        correctPrediction: 195,
        boostPointsEarned: '12,938'
      }))
    },

    streak: {
      stats: [
        { key: 'active_streak_users', label: 'Active Streak Users', value: '3,842', trend: 10.6, tone: 'gold' },
        { key: 'avg_streak_length', label: 'Avg Streak Length', value: '5.6 days', trend: 0.8, tone: 'blue' },
        { key: 'longest_streak', label: 'Longest Streak', value: '28 days', suffix: 'Alexander Boakye', tone: 'gold' }
      ],
      statsRow2: [
        { key: 'promotions_to_next_lvl', label: 'Promotions to Next Lvl', value: '1,246', trend: 18.3, tone: 'success' },
        { key: 'regressions', label: 'Regressions', value: '312', trend: -6.5, tone: 'danger' },
        { key: 'missed_broken', label: 'Missed/Broken', value: '1,102', trend: 0.2, tone: 'primary' }
      ],
      performanceStats: [
        { key: 'started_streaks', label: 'Started Streaks', value: '2,356', tone: 'gold' },
        { key: 'maintained_streak', label: 'Maintained Streak', value: '6,842', tone: 'blue' },
        { key: 'missed_streak', label: 'Missed Streak', value: '1,102', tone: 'purple' },
        { key: 'broken_streak', label: 'Broken Streak', value: '1,246', tone: 'purple' },
        { key: 'at_risk', label: 'At Risk (May Break)', value: '1,236', tone: 'purple' },
        { key: 'avg_streak_duration', label: 'Avg Streak Duration', value: '5.6 days', tone: 'purple' }
      ],
      performance: {
        tabs: [
          { key: 'active_users', label: 'Active Streak Users' },
          { key: 'started_vs_broken', label: 'Streaks Started vs Broken' },
          { key: 'bonus_earned', label: 'Streak Bonus Earned' }
        ],
        seriesByTab: {
          active_users: [{ key: 'active_users', label: 'Active Users', color: '#1976D2', data: buildSeries(rand, 2500, 1500) }],
          started_vs_broken: [
            { key: 'started', label: 'Started', color: '#34C759', data: buildSeries(rand, 1800, 800) },
            { key: 'broken', label: 'Broken', color: '#F87171', data: buildSeries(rand, 700, 400) }
          ],
          bonus_earned: [{ key: 'bonus_earned', label: 'Bonus Earned', color: '#1976D2', data: buildSeries(rand, 2500, 1500) }]
        }
      },
      rows: [
        { user: 'Kwame Boateng', level: 'Level 5', currentStreak: 28, coinsBonus: 28, pointsBonus: '2.5', progress: 40, status: 'Active', lastActivity: 'Jun 16, 2026 08:34' },
        { user: 'Esi Ofori', level: 'Level 3', currentStreak: 25, coinsBonus: 35, pointsBonus: '1.8', progress: 40, status: 'At Risk', lastActivity: 'Aug 05, 2026 14:00' },
        { user: 'Kwesi Agyeman', level: 'Level 1', currentStreak: 22, coinsBonus: 10, pointsBonus: '0.5', progress: 40, status: 'Active', lastActivity: 'Sep 12, 2026 11:30' },
        { user: 'Akua Mensah', level: 'Level 2', currentStreak: 25, coinsBonus: 20, pointsBonus: '1.0', progress: 40, status: 'At Risk', lastActivity: 'Oct 18, 2026 12:45' },
        { user: 'Nana Yaw', level: 'Level 6', currentStreak: 35, coinsBonus: 60, pointsBonus: '4.0', progress: 40, status: 'Active', lastActivity: 'Nov 30, 2026 13:00' },
        { user: 'Ama Serwaa', level: 'Level 5', currentStreak: 30, coinsBonus: 55, pointsBonus: '3.8', progress: 40, status: 'Active', lastActivity: 'Dec 1, 2026 11:00' },
        { user: 'Kwame Nkrumah', level: 'Level 7', currentStreak: 40, coinsBonus: 70, pointsBonus: '4.5', progress: 40, status: 'Active', lastActivity: 'Dec 2, 2026 12:00' },
        { user: 'Akosua Agyemang', level: 'Level 4', currentStreak: 28, coinsBonus: 50, pointsBonus: '3.5', progress: 40, status: 'Pending', lastActivity: 'Dec 3, 2026 09:00' }
      ]
    },

    branch: {
      stats: [
        { key: 'active_branches', label: 'Active Branches', value: '12', tone: 'purple' },
        { key: 'top_branch', label: 'Top Branch', value: 'Tema Community', tone: 'primary' },
        { key: 'top_branch_sales', label: 'Top Branch Sales', value: 'NGN 1,240,000', tone: 'success' },
        { key: 'avg_sales_per_branch', label: 'Avg Sales Per Branch', value: 'NGN 354,166', tone: 'gold' },
        { key: 'referral_participants', label: 'Referral Participants', value: '2,451', trend: 8.4, tone: 'blue' }
      ],
      performance: {
        tabs: [
          { key: 'sales', label: 'Sales' },
          { key: 'participants', label: 'Participants' },
          { key: 'referrals', label: 'Referrals' }
        ],
        seriesByTab: {
          sales: [{ key: 'sales', label: 'Sales', color: '#1976D2', data: buildSeries(rand, 65000, 40000) }],
          participants: [{ key: 'participants', label: 'Participants', color: '#7C3AED', data: buildSeries(rand, 900, 400) }],
          referrals: [{ key: 'referrals', label: 'Referrals', color: '#34C759', data: buildSeries(rand, 300, 150) }]
        }
      },
      branchSales: {
        centerLabel: 'Total Sales',
        centerValue: 'NGN 5,000,000',
        data: [
          { label: 'Tema Community', percent: 29, color: '#1976D2' },
          { label: 'Spintex Road', percent: 39, color: '#7C3AED' },
          { label: 'Mataheko Market', percent: 20, color: '#60A5FA' },
          { label: 'Achimota Branch', percent: 12, color: '#34C759' }
        ]
      },
      rows: Array.from({ length: 8 }, (_, i) => ({
        id: `BR-${i}`,
        branch: ['Tema Community', 'Spintex Road', 'Mataheko Market', 'Achimota Branch', 'Kaneshie', 'Osu', 'Adenta', 'Madina'][i],
        location: 'Accra, Ghana',
        participants: 1200 - i * 80,
        sales: `NGN ${(1240000 - i * 90000).toLocaleString()}`,
        growth: `${(18 - i * 1.6).toFixed(1)}%`,
        status: i % 4 === 3 ? 'Inactive' : 'Active'
      }))
    },

    customerInsight: {
      stats: [
        { key: 'total_customers', label: 'Total Customers', value: '12', tone: 'purple' },
        { key: 'new_customers', label: 'New Customers', value: '10', tone: 'success' },
        { key: 'repeat_customers', label: 'Repeat Customers', value: 'Tema Community', tone: 'blue' },
        { key: 'average_spend', label: 'Average Spend', value: '2.4', tone: 'gold' },
        { key: 'transaction_per_customer', label: 'Transaction Per Customer', value: '2', tone: 'primary' }
      ],
      trends: {
        tabs: [
          { key: 'acquisition', label: 'Customer Acquisition' },
          { key: 'satisfaction', label: 'Customer Satisfaction' }
        ],
        seriesByTab: {
          acquisition: [{ key: 'acquisition', label: 'Acquisition', color: '#1976D2', data: buildSeries(rand, 2.5, 2) }],
          satisfaction: [{ key: 'satisfaction', label: 'Satisfaction', color: '#1976D2', data: buildSeries(rand, 3, 2) }]
        }
      },
      acquisitionBars: [
        { label: 'NGN 0 - NGN 26', percent: 36 },
        { label: 'April 16', percent: 28 },
        { label: 'April 17', percent: 21 },
        { label: 'April 18', percent: 15 }
      ],
      branchSaleContribution: {
        centerLabel: 'Total Sales',
        centerValue: '8,742',
        data: [
          { label: 'New Customers', percent: 24.5, color: '#1976D2' },
          { label: 'Occasional Customers', percent: 41.2, color: '#7C3AED' },
          { label: 'Repeat Customers', percent: 34.3, color: '#34C759' }
        ]
      },
      customerSatisfaction: {
        centerLabel: 'Total Sales',
        centerValue: '8,742',
        data: [
          { label: 'Visit', percent: 45, color: '#1976D2' },
          { label: '2-3 Visits', percent: 32.6, color: '#7C3AED' },
          { label: '4-10 Visits', percent: 15.6, color: '#60A5FA' },
          { label: '10+ Visits', percent: 6.8, color: '#34C759' }
        ]
      },
      topCities: [
        { label: 'Lagos', percent: 28, color: '#34C759' },
        { label: 'Abuja', percent: 14.6, color: '#34C759' },
        { label: 'Ibadan', percent: 8.9, color: '#DCA815' },
        { label: 'Port Harcourt', percent: 6.2, color: '#F87171' },
        { label: 'Kano', percent: 4.8, color: '#F87171' }
      ],
      rows: Array.from({ length: 8 }, () => ({
        customer: 'Kehinda A',
        transactions: 4,
        spend: '12,323',
        visits: 3,
        rating: 4.8,
        topInterest: 'Fuel Recharge',
        lastInteraction: 'Jun 10, 2026'
      }))
    },

    prizes: {
      stats: [
        { key: 'total_prize_pool', label: 'Total Prize Pool', value: 'NGN 1,050,000', suffix: '100% allocated', tone: 'gold' },
        { key: 'active_prize_types', label: 'Active Prize Types', value: '5', tone: 'purple' },
        { key: 'weekly_winners', label: 'Weekly Winners', value: '20', suffix: 'Winners each week', tone: 'blue' },
        { key: 'monthly_winners', label: 'Monthly Winners', value: '3', suffix: 'Winners each month', tone: 'gold' },
        { key: 'next_draw', label: 'Next Draw', value: '2', suffix: 'Weekly Draw', tone: 'purple' }
      ],
      distribution: {
        centerLabel: 'Total Pool',
        centerValue: 'NGN 5,000,000',
        data: [
          { label: 'Fuel Voucher (50,000)', percent: 28.6, color: '#34C759' },
          { label: 'Fuel Voucher (20,000)', percent: 22.9, color: '#1976D2' },
          { label: 'Grocery Voucher (10,000)', percent: 19, color: '#DCA815' },
          { label: 'Recharge Card (5,000)', percent: 14.3, color: '#7C3AED' },
          { label: 'Free Fuel for a Month', percent: 15.2, color: '#60A5FA' }
        ]
      },
      topBranches: [
        { key: 'weekly_draw', label: 'Weekly Draw', description: 'Top scores & lucky draw winners', percent: 28.6, time: '11:00 AM' },
        { key: 'monthly_draw', label: 'Monthly Draw', description: 'Top scores (Special Prize)', percent: 28.6, time: '11:00 AM' }
      ],
      rows: Array.from({ length: 7 }, () => ({
        prizeName: 'Fuel Voucher',
        prizeValue: 'NGN 50,000',
        rank: 4,
        value: 'NGN 50,000',
        date: '23 Oct 2026',
        winnerType: 'Top Scorers',
        drawFrequency: 'Weekly',
        status: 'Active'
      }))
    },

    review: {
      stats: [
        { key: 'average_rating', label: 'Average Rating', value: '4.44', suffix: '/5', trend: 12.6, tone: 'gold' },
        { key: 'total_reviews', label: 'Total Reviews', value: '1,234', trend: 0, tone: 'blue' },
        { key: 'neutral', label: 'Neutral (3 Stars)', value: '13.6%', trend: -18.3, tone: 'gold' },
        { key: 'negative', label: 'Negative (1-2 Stars)', value: '9.0%', trend: 6.5, tone: 'danger' }
      ],
      ratingDistribution: [
        { label: '5 Stars', percent: 50, count: '648 (52%)', color: '#34C759' },
        { label: '4 Stars', percent: 26.7, count: '375 (26.7%)', color: '#34C759' },
        { label: '3 Stars', percent: 13.6, count: '168 (13.6%)', color: '#DCA815' },
        { label: '2 Stars', percent: 5.4, count: '71 (5.4%)', color: '#F87171' }
      ],
      rows: Array.from({ length: 7 }, (_, i) => ({
        id: `RV-${i}`,
        reviewer: 'John Doe',
        rating: 5,
        comment: 'Great service! Attendant was very helpful and fast',
        date: 'Jun 10, 2026',
        contactName: 'John Doe',
        email: 'example@company.com',
        contactType: 'Primary Contact',
        phone: '+234 567 8909'
      }))
    }
  }
}

export const CAMPAIGN_DETAIL_TOTAL = 24

export function getMockCampaignDetail(id) {
  const numericId = Number(id)
  const index = Number.isFinite(numericId) ? numericId : 0
  return buildCampaignDetail(index)
}
